
import { defineComponent } from "vue"

export default defineComponent({
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },

  computed: {
    isOpen: {
      get (): boolean {
        return this.value
      },
      set (value: boolean) {
        this.$emit("input", value)
      },
    },
  },
})
